import { Link } from "react-router-dom";
import React from "react";
import { formatDate } from "../../utils";
import { Group, Paper, Text } from "@mantine/core";

type Props = {
  id: string;
  order: number;
  infoBig?: string;
  infoSmall?: string;
  infoExtra?: string;
  link: string;
  date: string | Date;
};

/** Muted secondary line — emails, sort order, etc. */
function secondaryMetaColor(small?: string): string {
  if (!small) return "gray.7";
  if (small === "Główna") return "orange.8";
  return "gray.7";
}

/** Status / extra column — payment labels, etc. */
function extraLineColor(extra?: string): string {
  if (!extra) return "gray.7";
  if (extra.includes("Zapłacono")) return "green.8";
  if (extra.includes("Oczekujące")) return "orange.8";
  return "gray.7";
}

const ListElem: React.FC<Props> = ({
  order,
  infoBig,
  infoSmall,
  infoExtra,
  link,
  date,
}) => {
  const isEmptySlot = !infoBig;

  return (
    <Paper
      component={Link}
      to={link}
      p="md"
      mb="md"
      radius="md"
      withBorder
      bg="white"
      style={{
        textDecoration: "none",
        opacity: isEmptySlot ? 0.72 : 1,
        transition: "box-shadow 120ms ease, border-color 120ms ease",
      }}
      styles={{
        root: {
          borderColor: "var(--mantine-color-gray-3)",
          "&:hover": {
            borderColor: "var(--mantine-color-orange-4)",
            boxShadow: "var(--mantine-shadow-sm)",
          },
        },
      }}
    >
      <Group justify="space-between" wrap="nowrap" align="flex-start" gap="md">
        <Text span size="lg" fw={600} c="gray.6" miw={40} lh={1.4}>
          {order}.
        </Text>
        <div style={{ flex: 1, minWidth: 0 }}>
          {infoBig ? (
            <Group justify="space-between" align="flex-start" wrap="wrap" gap="xs">
              <div>
                <Text
                  span
                  size="lg"
                  fw={600}
                  c="dark.8"
                  style={{ lineHeight: 1.45 }}
                >
                  {infoBig}
                </Text>
                {infoSmall && (
                  <Text
                    span
                    size="sm"
                    c={secondaryMetaColor(infoSmall)}
                    ml={6}
                    style={{ lineHeight: 1.45 }}
                  >
                    ({infoSmall})
                  </Text>
                )}
              </div>
              {infoExtra && (
                <Text
                  size="sm"
                  fw={500}
                  c={extraLineColor(infoExtra)}
                  style={{ lineHeight: 1.45 }}
                >
                  {infoExtra}
                </Text>
              )}
            </Group>
          ) : (
            <Text size="lg" fs="italic" c="gray.6" lh={1.45}>
              Wolny termin
            </Text>
          )}
        </div>
        <Text
          size="sm"
          c="gray.6"
          fw={500}
          style={{ whiteSpace: "nowrap" }}
          lh={1.45}
        >
          {formatDate(new Date(date))}
        </Text>
      </Group>
    </Paper>
  );
};

export default ListElem;
